module.exports = __webpack_public_path__ + "static/media/assets_preview.3267c0c7.png";